var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-bbox": "30 30 140 140",
    "data-type": "color",
    viewBox: "30 30 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-m69434ay3__item1 svg [data-color=&quot;1&quot;]{fill:#1d0e03}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M170 100c0 38.66-31.34 70-70 70s-70-31.34-70-70 31.34-70 70-70 70 31.34 70 70z",
    "data-color": 1,
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M160.1 100c0 33.192-26.908 60.1-60.1 60.1S39.9 133.192 39.9 100 66.808 39.9 100 39.9s60.1 26.908 60.1 60.1z",
    "data-color": 1,
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M150 100c0 27.614-22.386 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50z",
    "data-color": 1,
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M140 100c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40z",
    "data-color": 1,
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M124.942 93.013c3.86 13.773-4.177 28.068-17.95 31.928-13.773 3.86-28.069-4.176-31.929-17.95-3.86-13.773 4.177-28.068 17.95-31.928 13.773-3.86 28.068 4.176 31.929 17.95z",
    "data-color": 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M170 100c0 38.66-31.34 70-70 70s-70-31.34-70-70 31.34-70 70-70 70 31.34 70 70z",
    "data-color": 1,
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M160.1 100c0 33.192-26.908 60.1-60.1 60.1S39.9 133.192 39.9 100 66.808 39.9 100 39.9s60.1 26.908 60.1 60.1z",
    "data-color": 1,
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M150 100c0 27.614-22.386 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50z",
    "data-color": 1,
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M140 100c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40z",
    "data-color": 1,
    opacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8344a",
    d: "M124.942 93.013c3.86 13.773-4.177 28.068-17.95 31.928-13.773 3.86-28.069-4.176-31.929-17.95-3.86-13.773 4.177-28.068 17.95-31.928 13.773-3.86 28.068 4.176 31.929 17.95z",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.38ec1bbf1d4c9fb91eda6521485e4c43.svg";
export { ForwardRef as ReactComponent };